import { Box, Container, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import PageStart from "../components/PageStart";
import TransitionComponent from "../components/TransitionComponent";
import { InfiniteRollingLogos } from "../components/InfiniteRollingLogos";
import { getFullSizeImagePath, getPlaceholderImagePath } from "./utils";
import { usePageTitle } from "../hooks/usePageTitle";

function About(props) {
  const lessMD = props.lessMD;
  const styles = {
    media: {
      height: 0,
      paddingTop: "56.25%", // 16:9
    },
    card: {
      position: "relative",
      border: "0px",
    },
    overlay: {
      position: "absolute",
      textAlign: "center",
      fontSize: "40pt",
      margin: "auto",
      top: "100px",
      width: "100%",
      color: "white",
      backgroundColor: "transparent",
    },
    container: {
      width: lessMD ? "90%" : "70%",
      backgroundColor: "transparent",
      borderColor: "transparent",
      boxShadow: "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      zIndex: 5000,
    },
    container1: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      boxShadow: "none",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      zIndex: 5000,
    },
    astronaut: {
      width: props.lessMD ? "100%" : "90%",
      mt: { xs: 48, sm: 50, md: 80, lg: 80, xl: 90 },
      position: "absolute",
      filter: props.lessMD ? "brightness(20%)" : null,

      border: "0px",
      right: props.lessMD ? "0" : "5%",
      zIndex: 1,
    },
    demon: {
      width: props.lessMD ? "100%" : "90%",
      mt: { xs: 188, sm: 190, md: 180, lg: 180, xl: 190 },
      position: "absolute",
      filter: props.lessMD ? "brightness(20%)" : null,

      border: "0px",
      right: props.lessMD ? "0" : "5%",
      zIndex: 1,
    },
    body1: {
      fontSize: { xs: 12, sm: 13, md: 16, lg: 16, xl: 17 },
      zIndex: 1000,
    },
    h1: {
      maxWidth: { xs: 350, sm: 400, md: 800, lg: 1000, xl: 1400 },
      margin: "auto",
      mt: { xs: 3, sm: 5, md: 4, lg: 7, xl: 8 },
      mb: { xs: 3, sm: 5, md: 2, lg: 7, xl: 8 },
      fontSize: { xs: 24, sm: 29, md: 36, lg: 45, xl: 54 },
      zIndex: 1000,
    },
    h2: {
      maxWidth: { xs: 350, sm: 400, md: 800, lg: 1000, xl: 1400 },
      mt: 6,
      mb: 1,
      textTransform: "uppercase",
      fontSize: { xs: 24, sm: 29, md: 36, lg: 45, xl: 54 },
      color: "#fb8901",
      WebkitTextFillColor: "#fb8901",
      zIndex: 1000,
    },
  };
  const [show, setShow] = useState(false);

  usePageTitle("Company");

  useEffect(() => {
    const onPageLoad = () => {
      setShow(true);
    };
    // Check if the page has already loaded
    if (document.readyState === "complete") {
      window.setTimeout(() => {
        setShow(true);
      }, 500);
    } else {
      window.addEventListener("load", onPageLoad);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);
  const imageName = "about";
  return (
    <Fragment>
      <PageStart
        title="ABOUT US"
        img={getFullSizeImagePath(imageName, props.lessMD)}
        placeholderImg={getPlaceholderImagePath(imageName, props.lessMD)}
        brightness={70}
      />
      {show ? (
        <Fragment>
          <InfiniteRollingLogos
            lessMD={props.lessMD}
            mb={{ xs: 4, sm: 5, md: 8, lg: 10, xl: 12 }}
            show={show}
          />
          <Box
            sx={{
              visibility: show ? "visible" : "hidden",
            }}
          >
            <Grid
              container
              direction="column"
              justifyContent={"center"}
              disablegutters="true"
              sx={styles.container1}
            >
              <TransitionComponent delay={500}>
                <Typography
                  paragraph
                  align="center"
                  variant="h2"
                  sx={styles.h1}
                >
                  OUR MISSION
                </Typography>
              </TransitionComponent>
              <Container sx={styles.container}>
                <TransitionComponent delay={500}>
                  <Typography
                    variant="body1"
                    paragraph
                    align="center"
                    sx={styles.body1}
                  >
                    We empower companies to accelerate game production while
                    upholding the highest visual standards, delivering fast,
                    seamless production with simple and effective budget
                    planning.
                  </Typography>
                </TransitionComponent>
              </Container>
            </Grid>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  WHO WE ARE
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  align="left"
                  sx={styles.body1}
                >
                  We provide end-to-end premium quality visual services
                  including creative direction, concept art, illustration, 2D
                  animation, UI design, front-end development, trailers and
                  promo materials.
                </Typography>
              </TransitionComponent>
            </Container>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  PERFORMANCE
                </Typography>
                <Typography
                  variant="body1"
                  sx={styles.body1}
                  paragraph
                  align="left"
                >
                  Starting a new partnership shouldn't slow you down. Our
                  dedicated team integrates seamlessly, asking all the right
                  questions upfront, so your production hits peak performance in
                  record time.
                </Typography>
              </TransitionComponent>
            </Container>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  PREDICTABILITY
                </Typography>
                <Typography
                  style={{ color: "#ffffff" }}
                  variant="body1"
                  paragraph
                  align="left"
                  sx={styles.body1}
                >
                  No hidden costs. No pricing uncertainty. Enjoy a flat
                  predictable rate that eliminates admin overhead and simplifies
                  budget planning.
                </Typography>
              </TransitionComponent>
            </Container>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  RESULTS
                </Typography>
                <Typography
                  style={{ color: "#ffffff" }}
                  variant="body1"
                  paragraph
                  align="left"
                  sx={styles.body1}
                >
                  Our studio grows through word of mouth. Our goal is to
                  consistently deliver high-quality results and build long-term
                  partnerships that inspire our partners to recommend us to
                  others.
                </Typography>
              </TransitionComponent>
            </Container>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  FAST-GROWING TEAM
                </Typography>
                <Typography
                  style={{ color: "#ffffff" }}
                  variant="body1"
                  paragraph
                  align="left"
                  sx={styles.body1}
                >
                  By hiring driven and talented individuals, we cultivate a
                  fast-growing team that delivers results at the highest
                  standard.
                </Typography>
              </TransitionComponent>
            </Container>
            <Container sx={styles.container}>
              <TransitionComponent delay={500}>
                <Typography variant="h2" sx={styles.h2} paragraph align="left">
                  SETTING NEW STANDARDS
                </Typography>
                <Typography
                  style={{ color: "#ffffff" }}
                  variant="body1"
                  paragraph
                  align="left"
                  sx={{ ...styles.body1, mb: 12 }}
                >
                  Recognizing our shared values and commitment to excellence,
                  we've joined forces with{" "}
                  <a
                    href="https://www.onyx.studio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#fb8901" }}
                  >
                    Onyx Studio
                  </a>{" "}
                  to create the world's premier end-to-end production ecosystem
                  and set a new standard for interactive storytelling.
                </Typography>
              </TransitionComponent>
            </Container>
          </Box>
        </Fragment>
      ) : (
        <Box sx={{ width: "100%", height: 5000 }}></Box>
      )}
    </Fragment>
  );
}

export default About;
